import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { ClipboardModule } from "@ag-grid-enterprise/clipboard";
import { ColumnsToolPanelModule } from "@ag-grid-enterprise/column-tool-panel";
import { LicenseManager } from "@ag-grid-enterprise/core";
import { ExcelExportModule } from "@ag-grid-enterprise/excel-export";
import { FiltersToolPanelModule } from "@ag-grid-enterprise/filter-tool-panel";
import { MenuModule } from "@ag-grid-enterprise/menu";
import { MultiFilterModule } from "@ag-grid-enterprise/multi-filter";
import { RangeSelectionModule } from "@ag-grid-enterprise/range-selection";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
import { ServerSideRowModelModule } from "@ag-grid-enterprise/server-side-row-model";
import { SetFilterModule } from "@ag-grid-enterprise/set-filter";
import { SideBarModule } from "@ag-grid-enterprise/side-bar";

export const appInitAgGrid = () => {
  LicenseManager.setLicenseKey(
    "Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-058033}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{MayBern_Solutions,_Inc.}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{maybern.com}_only_for_{3}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{maybern.com}_need_to_be_licensed___{maybern.com}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{1_June_2025}____[v3]_[0102]_MTc0ODczMjQwMDAwMA==3226b311afc44514a6047af502be0c1e",
  );
  ModuleRegistry.registerModules([
    ClientSideRowModelModule,
    ExcelExportModule,
    RangeSelectionModule,
    RowGroupingModule,
    ClipboardModule,
    ServerSideRowModelModule,
    SideBarModule,
    ColumnsToolPanelModule,
    MenuModule,
    MultiFilterModule,
    SetFilterModule,
    FiltersToolPanelModule,
  ]);
};
